// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import * as ActiveStorage from "@rails/activestorage"
import $ from "jquery"
import "slick-carousel"
import "./cascading-dropdown"
import "./modal"
import Cookies from "js-cookie"

Rails.start()
ActiveStorage.start()

$(function() {
  $(".p-univ__list.top").slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay : true,
    prevArrow: "<div class='p-univ__prev p-univ__btn'></div>",
    nextArrow: "<div class='p-univ__next p-univ__btn'></div>",
    responsive: [
      {
        breakpoint: 896,
        settings: {
          slidesToShow: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  })

  $(".p-interview__list.top").slick({
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay : true,
    prevArrow: "<div class='p-univ__prev p-univ__btn'></div>",
    nextArrow: "<div class='p-univ__next p-univ__btn'></div>",
    responsive: [
      {
        breakpoint: 896,
        settings: {
          slidesToShow: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  })

  $('.p-detail-slider .slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.slider-nav'
  });

  $('.p-detail-slider .slider-nav').slick({
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.slider',
    centerMode: true,
    focusOnSelect: true,
    arrows: false
  });


  $(".p-pickup__list.top").slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    prevArrow: "<div class='p-univ__prev p-univ__btn'></div>",
    nextArrow: "<div class='p-univ__next p-univ__btn'></div>",
    responsive: [
      {
        breakpoint: 896,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  })

  $(".recommended_jobs").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay : true,
    prevArrow: "<div class='p-univ__prev p-univ__btn'></div>",
    nextArrow: "<div class='p-univ__next p-univ__btn'></div>",
    responsive: [
      {
        breakpoint: 896,
        settings: {
          slidesToShow: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  })

  $('.banner-close').on('click', function() {
    $(this).parent().hide();
    Cookies.set("line_banner", "close", {expires: 1});
  })

  $(window).on("scroll", function() {
    if (Cookies.get("line_banner") !== "close") {
      if ($(this).scrollTop() > 200) {
          $(".banner").fadeIn(300)
      }
    }
  })

  $(window).on('scroll load', function() {
    if ($(this).scrollTop() > 0) {
      $('.l-header').addClass('is-scroll');
    } else {
      $('.l-header').removeClass('is-scroll');
    }
  });

  $('.p-header-toggle').on('click', function() {
    $(".p-hnav").toggleClass("is-active");
    $("body").toggleClass("is-active");
  });

  // SP表示: 詳細検索条件の表示（開くのみ）
  if (window.matchMedia('(max-width: 896px)').matches) {
    // 詳細条件が選択済みの場合は常時表示（is-openクラスで判定）
    if (!$('.p-search__add').hasClass('is-open')) {
      $('.c-search__more-btn').on('click', function() {
        $('.p-search__add').addClass('is-open');
        $(this).hide();
      });
    }
  }

  // メール登録フォーム: メールアドレス入力でsubmitボタンを有効化
  $('[id^="mail_subscribe_user_form_"] input[type="text"]').on('input', function() {
    var $form = $(this).closest('form');
    var $submit = $form.find('input[type="submit"]');
    if ($(this).val().trim() !== '') {
      $submit.prop('disabled', false);
    } else {
      $submit.prop('disabled', true);
    }
  });
})
